<div class="info-container" [class.add-type]="isAddType" (click)="onAddClick()">
  <div class="left-section">
    <div class="main-icon" [ngStyle]="mainIconStyle">
      <mat-icon svgIcon="{{mainIcon}}"></mat-icon>
    </div>
    <div class="content">
      <div class="header-text">{{headerText}}</div>
      <div class="subtitle-text" *ngIf="!isAddType">{{subtitleText}}</div>
    </div>
  </div>
  <div class="right-section">
    <div 
      class="action-icon" 
      *ngFor="let actionIcon of actionIcons"
      [title]="actionIcon.tooltip"
      (click)="onActionClick(actionIcon.action); $event.stopPropagation()">
      <mat-icon svgIcon="{{actionIcon.icon}}"></mat-icon>
    </div>
  </div>
</div>